export default __webpack_public_path__ + "static/media/about-icon1.e178b8c1.svg";